import { getNextApiRoute } from './api';

declare global {
    interface Window {
        adyenGetData?: () => string;
    }
}

export const getAdyenClientData = (): string => {
    if (window.adyenGetData && typeof window.adyenGetData === 'function') {
        const data = window.adyenGetData();

        return typeof data === 'string' ? data : '';
    }

    return '';
};

export const fetchShopperIp = async (): Promise<string> => {
    const response = await fetch(getNextApiRoute('ip'));
    const data = await response.json();
    return typeof data === 'string' ? data : JSON.stringify(data);
};
